<template>
    <form @submit.prevent="validateForm()"
          data-vv-scope="raw_material"
    >
        <b-row>
            <b-col md="10"
                   class="mb-2"
            >
                <label for="name">Materia prima</label>
                <el-input id="name"
                          name="name"
                          size="small"
                          type="text"
                          v-model="raw_material.raw_material.name"
                          data-vv-as=" "
                          v-validate="'required'"
                />
                <span class="text-danger small"
                      v-text="errors.first('raw_material.name')"
                />
            </b-col>

            <b-col md="2">
                <label for="percentage">% Usado</label>
                <el-input id="percentage"
                          name="percentage"
                          size="small"
                          type="text"
                          v-model="raw_material.percentage"
                          data-vv-as=" "
                          v-validate="'required|decimal:4|min_value:0.001|max_value:100'"
                />
                <span class="text-danger small"
                      v-text="errors.first('raw_material.percentage')"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12"
                   class="text-center"
            >
                <hr class="mt-0 mb-2">
                <b-button @click="_closeModal"
                          variant="secondary"
                          class="float-left"
                          size="sm"
                >
                    <i class="fa fa-close"></i> Cancelar
                </b-button>
                <b-button @click="validateForm"
                          variant="primary"
                          class="float-right"
                          size="sm"
                >
                    Siguiente
                    <i class="fa fa-arrow-right"></i>
                </b-button>
            </b-col>
        </b-row>
    </form>
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';

export default {
    name: 'raw_materials',
    computed: {
        ...mapState('calculator', [
            'modal_raw_material',
            'raw_material',
            'product',
            'action_raw_material',
            'raw_materials'
        ])
    },
    created() {
        this.setPaginateFilter(false);
    },
    methods: {
        ...mapActions('calculator', [
            'getManufacturers',
            'createRawMaterial',
            'updateRawMaterial',
            'getRawMaterials',
            'getProduct'
        ]),
        ...mapMutations('calculator', [
            'setModalRawMaterialShow',
            'setPaginateFilter',
            'setShowToModalWizard',
            'setActionComponent'
        ]),
        async _closeModal() {
            this.setShowToModalWizard(false);
            const product_id = this.$route.params.product_id;
            const company_id = this.$route.params.company_id;

            await this.getProduct({product_id, company_id});
        },
        validateForm() {
            this.$validator.validateAll('raw_material')
                .then(async (result) => {
                    if (result) {
                        if (this.action_raw_material === 'Crear') {
                            await this.createRawMaterial();
                        } else if (this.action_raw_material === 'Editar') {
                            await this.updateRawMaterial(this.raw_material);
                        }
                    }
                });
        }
    }
};
</script>

<style scoped>

</style>
